import { useState } from 'react';
import { toast } from 'react-toastify';
import { Wallet, CreditCard } from 'lucide-react';
import PaymentButton from './PaymentButton';

const PAYMENT_PROVIDERS = [
  {
    id: 'razorpay',
    label: 'Razorpay',
    icon: Wallet,
    enabled: true,
    description: 'Cards, UPI, Net banking, Wallets',
  },
  {
    id: 'stripe',
    label: 'Stripe',
    icon: CreditCard,
    enabled: false,
    comingSoon: true,
  },
];

const PaymentMethodSelector = ({ plan, cycle, billingFormData, billingErrors, setBillingErrors }) => {
  const [provider, setProvider] = useState('razorpay');

  const handleProviderClick = (p) => {
    if (p.comingSoon) {
      toast.info('Stripe is coming soon. Please use Razorpay for now.');
      return;
    }
    setProvider(p.id);
  };

  const isValid =
    (billingFormData?.name || '').trim().length > 0 &&
    /^[0-9]{10}$/.test((billingFormData?.mobile || '').trim());

  return (
    <>
      <div className="mb-4">
        <p className="text-sm font-medium text-gray-700 mb-2">Payment method</p>
        <div className="flex flex-wrap gap-2">
          {PAYMENT_PROVIDERS.map((p) => {
            const Icon = p.icon;
            const isSelected = provider === p.id;
            const isDisabled = !p.enabled;
            return (
              <button
                key={p.id}
                type="button"
                onClick={() => handleProviderClick(p)}
                className={`flex items-center gap-2 px-4 py-2.5 rounded-lg border font-medium transition ${
                  isDisabled
                    ? 'bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed'
                    : isSelected
                    ? 'bg-black text-white border-black'
                    : 'bg-white border-gray-300 hover:border-gray-400'
                }`}
              >
                <Icon size={18} />
                {p.label}
                {p.comingSoon && (
                  <span className="text-xs opacity-90 truncate">(Coming Soon)</span>
                )}
              </button>
            );
          })}
        </div>
        {provider === 'razorpay' && (
          <p className="text-xs text-gray-500 mt-1.5">
            Razorpay supports Cards, UPI, Net banking & Wallets
          </p>
        )}
      </div>

      <div className="mt-6">
        <PaymentButton
          provider={provider}
          plan={plan}
          cycle={cycle}
          disabled={provider !== 'razorpay' || !isValid}
          isValid={isValid}
          billingFormData={billingFormData}
          billingErrors={billingErrors}
          setBillingErrors={setBillingErrors}
        />
      </div>
    </>
  );
};

export default PaymentMethodSelector;
